import { useState, lazy, Suspense } from "react";
import { ArrowRight, BookOpen, Shield, ChevronDown, ChevronUp, CreditCard, Lock, Clock, Info } from "lucide-react";
import { Button } from "@/components/ui/button";
const PaymentLogoChip = lazy(() =>
  import("@/components/PaymentLogoPill").then(m => ({ default: m.PaymentLogoChip }))
);
import logo1  from "@assets/logos_extracted/1.png";
import logo2  from "@assets/logos_extracted/2.png";
import logo3  from "@assets/logos_extracted/3.png";
import logo4  from "@assets/logos_extracted/4.png";
import logo5  from "@assets/logos_extracted/5.png";
import logo6  from "@assets/logos_extracted/6.png";
import logo7  from "@assets/logos_extracted/7.png";
import logo8  from "@assets/logos_extracted/8.png";
import logo9  from "@assets/logos_extracted/9.png";
import logo10 from "@assets/logos_extracted/10.png";
import logo11 from "@assets/logos_extracted/11.png";
import logo12 from "@assets/logos_extracted/12.png";
import logo13 from "@assets/logos_extracted/13.png";
import logo14 from "@assets/logos_extracted/14.png";
import logo15 from "@assets/logos_extracted/15.png";
import logo16 from "@assets/logos_extracted/16.png";
import logo17 from "@assets/logos_extracted/17.png";
import logo18 from "@assets/logos_extracted/18.png";
import logo19 from "@assets/logos_extracted/19.png";
import logo20 from "@assets/Untitled_design_(24)_1773076880991.png";
import logo21 from "@assets/Untitled_design_(25)_1773077218464.png";

type Casino = {
  id: number;
  name: string;
  initials: string;
  color: string;
  wager: string;
  bonus: string;
  bonusLabel: string;
  reward: string;
  rewardLabel: string;
  logo?: string;
  url: string;
  reviewUrl?: string;
};

type PaymentMethod = {
  name: string;
  slug: string;
};

const PAYMENT_METHODS: PaymentMethod[] = [
  { name: "Visa",            slug: "visa" },
  { name: "Mastercard",      slug: "mastercard" },
  { name: "Maestro",         slug: "maestro" },
  { name: "Bankovní převod", slug: "bank-transfer" },
  { name: "Skrill",          slug: "skrill" },
  { name: "Skrill 1-Tap",    slug: "skrill-1-tap" },
  { name: "Neteller",        slug: "neteller" },
  { name: "MiFinity",        slug: "mifinity" },
  { name: "Jeton",           slug: "jeton" },
  { name: "eZeeWallet",      slug: "ezeewallet" },
  { name: "ecoPayz",         slug: "ecopayz" },
  { name: "MuchBetter",      slug: "muchbetter" },
  { name: "Interac",         slug: "interac" },
  { name: "PlayID",          slug: "playid" },
  { name: "Trustly",         slug: "trustly" },
  { name: "Klarna",          slug: "klarna" },
  { name: "Sofort",          slug: "sofort" },
  { name: "Revolut",         slug: "revolut" },
  { name: "Paysafecard",     slug: "paysafecard" },
  { name: "Neosurf",         slug: "neosurf" },
  { name: "CashtoCode",      slug: "cashtocode" },
  { name: "Apple Pay",       slug: "apple-pay" },
  { name: "Google Pay",      slug: "google-pay" },
  { name: "Boku",            slug: "boku" },
  { name: "Bitcoin",         slug: "bitcoin" },
  { name: "Ethereum",        slug: "ethereum" },
  { name: "Litecoin",        slug: "litecoin" },
  { name: "Ripple",          slug: "ripple" },
  { name: "Tether",          slug: "tether" },
  { name: "Solana",          slug: "solana" },
  { name: "BNB",             slug: "bnb" },
  { name: "Bitcoin Cash",    slug: "bitcoin-cash" },
  { name: "Dogecoin",        slug: "dogecoin" },
  { name: "Cardano",         slug: "cardano" },
  { name: "USD Coin",        slug: "usd-coin" },
  { name: "Tron",            slug: "tron" },
  { name: "PIX",             slug: "pix" },
  { name: "PicPay",          slug: "picpay" },
];

const casinos: Casino[] = [
  { id: 1,  name: "OnlySpins",      initials: "OS", color: "#003da5", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo1,  url: "https://ons.lynmonkel.com/?mid=279656_1882080", reviewUrl: "/kasina/onlyspins" },
  { id: 2,  name: "Allyspin",       initials: "AS", color: "#8b0000", wager: "Požadavek na protočení 35×", bonus: "až 25 000 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo2,  url: "https://all.monvaki.com/?mid=282906_1667056", reviewUrl: "/kasina/allyspin" },
  { id: 3,  name: "Legiano",        initials: "LE", color: "#1a4d6e", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo3,  url: "https://lgno.monvaki.com/?mid=282906_1666929", reviewUrl: "/kasina/legiano" },
  { id: 4,  name: "Bassbet",        initials: "BB", color: "#2d4a00", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo4,  url: "https://bsbt.fynkelto.com/?mid=279656_1645822", reviewUrl: "/kasina/bassbet" },
  { id: 5,  name: "FastSlots",      initials: "FS", color: "#003da5", wager: "Požadavek na protočení 35×", bonus: "až 125 000 Kč", bonusLabel: "Bonus",  reward: "50",   rewardLabel: "Freespiny", logo: logo5,  url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM88TL4kmJ7MEGNd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/fastslots" },
  { id: 6,  name: "Spinanga",       initials: "SP", color: "#4a006e", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo6,  url: "https://spng.fynkelto.com/?mid=279656_1645837", reviewUrl: "/kasina/spinanga" },
  { id: 7,  name: "Rabona",         initials: "RA", color: "#6e2400", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo7,  url: "https://rbn.fynkelto.com/?mid=279656_1645828", reviewUrl: "/kasina/rabona" },
  { id: 8,  name: "Casinia",        initials: "CA", color: "#005a3c", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo8,  url: "https://csn.fynkelto.com/?mid=279656_1645832", reviewUrl: "/kasina/casinia" },
  { id: 9,  name: "Stone Vegas",    initials: "SV", color: "#4a3a2a", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo9,  url: "https://stnvgs.fynkelto.com/?mid=308616_1816138", reviewUrl: "/kasina/stone-vegas" },
  { id: 10, name: "Golden Panda",   initials: "GP", color: "#7a4a00", wager: "Požadavek na protočení 30×", bonus: "až 125 000 Kč", bonusLabel: "Bonus",  reward: "50",   rewardLabel: "Freespiny", logo: logo10, url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM98YAuMxhPI-WNd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/golden-panda" },
  { id: 11, name: "Instant Casino", initials: "IC", color: "#6e006e", wager: "Požadavek na protočení 30×", bonus: "až 185 000 Kč", bonusLabel: "Bonus",  reward: "10%",  rewardLabel: "Cashback",  logo: logo11, url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM-u11z-n_bVh2Nd7ZgqdRLk/1/?pg=1", reviewUrl: "/kasina/instant-casino" },
  { id: 12, name: "Boaboa",         initials: "BO", color: "#1a3d6e", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo12, url: "https://bbaw.monvaki.com/?mid=282906_1667067", reviewUrl: "/kasina/boaboa" },
  { id: 13, name: "Alf Casino",     initials: "AC", color: "#3d001a", wager: "Požadavek na protočení 35×", bonus: "až 20 000 Kč",  bonusLabel: "Bonus",  reward: "300",  rewardLabel: "Freespiny", logo: logo13, url: "https://alcw.monvaki.com/?mid=282906_1667062", reviewUrl: "/kasina/alf-casino" },
  { id: 14, name: "Cadoola",        initials: "CD", color: "#001a3d", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo14, url: "https://cadw.monvaki.com/?mid=282906_1667064", reviewUrl: "/kasina/cadoola" },
  { id: 15, name: "Bankonbet",      initials: "BK", color: "#003d1a", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo15, url: "https://bnkw.monvaki.com/?mid=282906_1667060", reviewUrl: "/kasina/bankonbet" },
  { id: 16, name: "Wazamba",        initials: "WZ", color: "#1a001a", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo16, url: "https://wzbw.monvaki.com/?mid=282906_1667059", reviewUrl: "/kasina/wazamba" },
  { id: 17, name: "SPINiT",         initials: "SI", color: "#003d3d", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo17, url: "https://swp.fynkelto.com/?mid=279656_1645821", reviewUrl: "/kasina/spinit" },
  { id: 18, name: "SG Casino",      initials: "SG", color: "#3d1a00", wager: "Požadavek na protočení 35×", bonus: "až 20 000 Kč",  bonusLabel: "Bonus",  reward: "250",  rewardLabel: "Freespiny", logo: logo18, url: "https://sgc.monvaki.com/?mid=282906_1667053", reviewUrl: "/kasina/sg-casino" },
  { id: 19, name: "Librabet",       initials: "LB", color: "#1a1a6e", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo19, url: "https://lrb.fynkelto.com/?mid=279656_1645829", reviewUrl: "/kasina/librabet" },
  { id: 20, name: "Nomini",         initials: "NO", color: "#003d1a", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo20, url: "https://nmn.fynkelto.com/?mid=279656_1645825", reviewUrl: "/kasina/nomini" },
  { id: 21, name: "Wyns",           initials: "WY", color: "#1a4d00", wager: "Požadavek na protočení 35×", bonus: "až 12 500 Kč",  bonusLabel: "Bonus",  reward: "200",  rewardLabel: "Freespiny", logo: logo21, url: "https://wns.fynkelto.com/?mid=311317_1933451" },
];

const rankMeta: Record<number, { label: string; dotClass: string; accent: string; bg: string; border: string; rankBg: string }> = {
  1: {
    label: "Top volba",
    dotClass: "bg-[#c9960f] text-white",
    accent: "#c9960f",
    bg: "linear-gradient(108deg, #fefaec 0%, #fdf8f0 50%, #ffffff 100%)",
    border: "border-[#c9960f]/30",
    rankBg: "linear-gradient(135deg, #b8860b 0%, #e6ac20 100%)",
  },
  2: {
    label: "Doporučeno",
    dotClass: "bg-[#6b7c8d] text-white",
    accent: "#6b7c8d",
    bg: "linear-gradient(108deg, #f4f5f7 0%, #f8f9fa 50%, #ffffff 100%)",
    border: "border-slate-300",
    rankBg: "linear-gradient(135deg, #5f6b7a 0%, #8ea0b2 100%)",
  },
  3: {
    label: "Oblíbené",
    dotClass: "bg-amber-600 text-white",
    accent: "#b45309",
    bg: "linear-gradient(108deg, #fef9ec 0%, #fdfaf3 50%, #ffffff 100%)",
    border: "border-amber-200/70",
    rankBg: "linear-gradient(135deg, #b45309 0%, #d97706 100%)",
  },
};

function RankBadge({ rank }: { rank: number }) {
  const meta = rankMeta[rank];
  if (rank <= 3) {
    return (
      <div className="flex flex-col items-center w-9 flex-shrink-0">
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center font-black text-base text-white"
          style={{ background: meta.rankBg, boxShadow: `0 2px 8px ${meta.accent}30` }}
        >
          {rank}
        </div>
      </div>
    );
  }
  return (
    <div className="w-9 flex-shrink-0 flex items-center justify-center">
      <span className="text-xl leading-none tabular-nums font-black text-[#003da5]">{rank}</span>
    </div>
  );
}

function OfferBlock({ value, label, primary }: { value: string; label: string; primary: boolean }) {
  return (
    <div className={`flex flex-col items-center justify-center px-3 py-2.5 rounded-lg sm:min-w-[80px] ${
      primary
        ? "bg-[#e8f0fe] border border-[#003da5]/30"
        : "bg-[#f1f3f7] border border-[#d4dae6]"
    }`}>
      <span className={`font-black text-base leading-tight ${primary ? "text-[#003da5]" : "text-gray-800"}`}>
        {value}
      </span>
      <span className="text-[9px] font-bold uppercase tracking-widest text-gray-500 mt-0.5 whitespace-nowrap">
        {label}
      </span>
    </div>
  );
}


function CasinoCard({ casino, rank }: { casino: Casino; rank: number }) {
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const meta = rankMeta[rank];
  const isTop3 = rank <= 3;
  const shadowAccent = rank === 1 ? meta.accent : "#003da5";

  return (
    <div
      className={`relative rounded-xl border overflow-hidden ${
        isTop3 ? meta.border : "border-[#003da5]/15"
      }`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: isTop3
          ? meta.bg
          : "linear-gradient(108deg, #eef3ff 0%, #f4f7ff 50%, #ffffff 100%)",
        boxShadow: hovered
          ? `0 6px 16px rgba(0,0,0,0.08), 0 12px 32px ${shadowAccent}45`
          : `0 2px 6px rgba(0,0,0,0.04), 0 6px 18px ${shadowAccent}28`,
        transform: hovered ? "translateY(-3px)" : "translateY(0)",
        transition: "box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease",
      }}
      data-testid={`casino-row-${casino.id}`}
    >
      <div
        className="absolute left-0 top-0 bottom-0 w-[3px]"
        style={{ background: isTop3 ? meta.accent : "#003da5" }}
      />
      <div className="pl-5 pr-5 pt-4 pb-0 sm:pl-6 sm:pr-6 sm:pt-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0">

          {/* MOBILE HEADER ROW: rank + logo + name/wager */}
          <div className="flex items-center gap-2.5 sm:contents">
            {/* ZONE 1 – RANK */}
            <div className="flex-shrink-0 sm:pr-4">
              <RankBadge rank={rank} />
            </div>

            {/* ZONE 2 – BRAND */}
            <div className="flex items-center gap-2.5 flex-1 min-w-0 sm:border-l sm:border-[#e4eaf3] sm:pl-4 sm:pr-5">
              <div
                className="w-12 h-12 sm:w-20 sm:h-20 rounded-xl sm:rounded-2xl flex-shrink-0 overflow-hidden"
                style={{
                  background: casino.logo ? "transparent" : casino.color,
                  boxShadow: `0 4px 14px ${shadowAccent}40`,
                }}
              >
                {casino.logo ? (
                  <img
                    src={casino.logo}
                    alt={casino.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center font-black text-xl text-white">
                    {casino.initials}
                  </div>
                )}
              </div>
              <div className="min-w-0">
                <div className="font-black text-gray-900 text-[15px] leading-snug truncate">
                  {casino.name}
                </div>
                <div className="text-[11px] mt-0.5 font-semibold leading-tight text-[#003da5]/80">
                  {casino.wager}
                </div>
                {isTop3 && (
                  <span
                    className={`inline-flex items-center justify-center mt-1.5 text-white text-[9px] font-bold px-2.5 py-1 rounded-full uppercase tracking-widest leading-none ${meta.dotClass}`}
                  >
                    {meta.label}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* ZONE 3+4 – OFFER + CTA */}
          <div className="w-full sm:w-auto sm:flex-shrink-0 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-10 sm:border-l sm:border-[#dde4ee] sm:pl-5">
            {/* offer blocks – 2-col grid on mobile, inline on desktop */}
            <div className="grid grid-cols-2 gap-2 w-full sm:w-auto sm:flex sm:items-center sm:gap-2">
              <OfferBlock value={casino.bonus} label={casino.bonusLabel} primary={true} />
              <OfferBlock value={casino.reward} label={casino.rewardLabel} primary={false} />
            </div>

            {/* cta column */}
            <div className="flex flex-col gap-1.5 w-full sm:w-auto sm:min-w-[114px]">
              <a href={casino.url} target="_blank" rel="sponsored noopener noreferrer" className="block w-full" aria-label={`Hrát ${casino.name}`}>
                <button
                  className="hraj-btn w-full flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-lg font-bold text-sm text-white transition-colors"
                  style={{ background: "#003da5" }}
                  onMouseEnter={e => (e.currentTarget.style.background = "#002d7c")}
                  onMouseLeave={e => (e.currentTarget.style.background = "#003da5")}
                  data-testid={`button-hraj-${casino.id}`}
                >
                  Hraj
                  <ArrowRight className="hraj-arrow w-3.5 h-3.5" />
                </button>
              </a>
              <a
                href={casino.reviewUrl ?? `#casino-recenze-${casino.id}`}
                className="flex items-center justify-center gap-1 py-1.5 text-[#003da5] text-xs font-semibold hover:text-[#002d7c] transition-colors w-full"
                data-testid={`button-recenzi-${casino.id}`}
              >
                <BookOpen className="w-3 h-3 flex-shrink-0" />
                Přečíst Recenzi
              </a>
            </div>
          </div>
        </div>

        {/* PAYMENT METHODS TRIGGER */}
        <div className="mt-3 border-t border-[#e8edf5]">
          <button
            onClick={() => setPaymentOpen(!paymentOpen)}
            className="w-full flex items-center justify-between py-2.5 text-gray-500 hover:text-[#003da5] transition-colors group"
            data-testid={`button-payment-toggle-${casino.id}`}
          >
            <span className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold text-gray-500">
              <CreditCard className="w-3.5 h-3.5" />
              Platební metody
            </span>
            <ChevronDown
              className={`w-3.5 h-3.5 transition-transform duration-200 ${paymentOpen ? "rotate-180" : ""}`}
            />
          </button>

          {paymentOpen && (
            <div className="pb-3">
              <div className="flex flex-wrap gap-1.5">
                <Suspense fallback={<div style={{ height: "40px" }} />}>
                  {PAYMENT_METHODS.map(m => (
                    <PaymentLogoChip key={m.slug} name={m.name} slug={m.slug} />
                  ))}
                </Suspense>
              </div>
            </div>
          )}
        </div>

        {/* ZONE 5 – TRUST FOOTER */}
        <div className="-mx-5 sm:-mx-6 px-5 sm:px-6 border-t border-[#dde4ee] py-2.5 bg-[#f3f5f9] flex items-center justify-between flex-wrap gap-x-4 gap-y-1">
          <span className="flex items-center gap-1.5 text-[11px] font-semibold text-gray-600">
            <Lock className="w-3 h-3 text-gray-500" />
            18+ | Hrajte zodpovědně
          </span>
          <span className="text-[11px] text-gray-500 font-semibold">Podmínky se vztahují</span>
        </div>
      </div>
    </div>
  );
}

export function CasinoRankings() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? casinos : casinos.slice(0, 10);

  return (
    <section id="rankings" className="py-16 bg-white -mt-1" data-testid="section-rankings">

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-gray-900 mb-2">
            Podívejte se na naše žebříčky a objevte ta nejlepší online kasina
          </h2>
          <div className="flex items-center justify-center gap-2 mt-3" data-testid="text-last-updated">
            <Clock className="w-3.5 h-3.5 text-[#003da5]" />
            <span className="text-sm text-gray-500 font-medium">
              Naposledy aktualizováno: {new Date().toLocaleDateString("cs-CZ", { day: "numeric", month: "long", year: "numeric" })}
            </span>
          </div>
        </div>

        <div
          className="flex items-start gap-2 mb-6 p-3 rounded-lg border border-[#003da5]/10"
          style={{ background: "linear-gradient(135deg, #f0f5ff 0%, #e8f0fe 100%)" }}
          data-testid="text-affiliate-inline"
        >
          <Info className="w-4 h-4 text-[#003da5] flex-shrink-0 mt-0.5" />
          <p className="text-xs text-gray-600 leading-relaxed">
            Některé odkazy jsou affiliate – kliknutím a registrací můžeme obdržet provizi. To nemá vliv na naše hodnocení ani na podmínky bonusů.
          </p>
        </div>

        <div className="flex flex-col gap-[30px] mb-6">
          {visible.map((casino, i) => (
            <CasinoCard key={casino.id} casino={casino} rank={i + 1} />
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 text-[#003da5] font-semibold text-sm hover:text-[#002d7c] transition-colors"
            data-testid="button-show-all-casinos"
          >
            {showAll ? (
              <><ChevronUp className="w-4 h-4" /> Zobrazit méně</>
            ) : (
              <>Zobrazit více ({casinos.length - 10} dalších) <ChevronDown className="w-4 h-4" /></>
            )}
          </button>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-gray-500 font-medium">
          <Shield className="w-3.5 h-3.5" />
          <span>Pouze kasina s platnou licencí. 18+ | Hrajte zodpovědně</span>
        </div>
      </div>
    </section>
  );
}
